import { ProductsGridView } from '~/components/product/grid';
import { PageContainer } from '~/components/page-container';

export function ProductsGrid() {
	return (
		<PageContainer>
			<ProductsGridView />
		</PageContainer>
	);
}
